module.exports = __webpack_public_path__ + "static/media/hu.7550d670.svg";